import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useWeb3Modal, useWeb3ModalProvider } from '@web3modal/ethers/react';
import { Web3Provider, useWeb3 } from './context/Web3Context';
import Header from './components/Header';
import NetworkWarning from './components/NetworkWarning';
import Markets from './pages/Markets';
import MyBets from './pages/MyBets';
import Opportunity from './pages/Opportunity';
import Admin from './pages/Admin';
import './App.css';

function AppContent() {
  const { connectWallet } = useWeb3();
  const { walletProvider } = useWeb3ModalProvider();

  useEffect(() => {
    connectWallet(walletProvider);
  }, [walletProvider, connectWallet]);

  return (
    <div className="app">
      <NetworkWarning />
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Markets />} />
          <Route path="/my-bets" element={<MyBets />} />
          <Route path="/opportunity/:id" element={<Opportunity />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Web3Provider>
        <AppContent />
      </Web3Provider>
    </Router>
  );
}

export default App;
